import { parse } from 'query-string';
export const getValueFromUrl = (url, key) => {
    const searchStr = String(url).split('?')[1];
    const accessToken = parse(searchStr)[key];
    return accessToken;
};
export const loadScript = (src) => new Promise(res => {
    const script = document.createElement('script');
    script.src = src;
    const head = document.head || document.documentElement;
    if (!head) {
        throw new Error('has not found neither head nor documentElement');
    }
    head.appendChild(script);
    script.onload = res;
});
/**
 * Wrapps an async function in a try/finally block. Re-used from homepage
 */
export const asyncTryFinally = (before, after) => fn => async (a, b) => {
    await before(a, b);
    try {
        return await fn(a, b);
    }
    finally {
        await after(a, b);
    }
};
/**
 * This function is for convert the facebook callback into a promise,
 * so we can 'wait' for it.
 * */
export const promisify = (fn) => (...args) => (...opts) => new Promise(res => fn(...args, res, ...opts));
//# sourceMappingURL=utils.js.map